module.exports = __webpack_public_path__ + "img/gif-focus-pt.6d49162f.gif";